function ListPageLayout({ title, tagline, sidebar, children }) {
  return (
    <div className="list-page">
      <div className="list-page-grid">
        <aside className="list-sidebar">
          <div className="list-sidebar-header">
            <h2>{title}</h2>
            {tagline && <p>{tagline}</p>}
          </div>
          {sidebar}
        </aside>
        <main>
          {children}
        </main>
      </div>
    </div>
  );
}

export default ListPageLayout;
